import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';

import { AdministrativeIndicationsReportService, IndicationScheduleOption } from '../../../../../../../services/administrative-indications-report-v2.service';

const URL_REGEX = /^https?:\/\/[^\s/$.?#][^\s]*\.[^\s]+$/i;

@Component({
    selector: 'app-schedule-report-panel',
    templateUrl: './schedule-report-panel.component.html',
    styleUrls: ['./schedule-report-panel.component.scss'],
})
export class ScheduleReportPanelComponent {
    @Input() schedule: IndicationScheduleOption;
    @Input() indicationId: number;
    @Output() attached = new EventEmitter<void>();

    form: FormGroup;
    saving = false;
    readonly today = new Date();

    constructor(
        private readonly fb: FormBuilder,
        private readonly service: AdministrativeIndicationsReportService,
        private readonly snack: MatSnackBar
    ) {
        this.form = this.fb.group({
            issuedAt: [null, [Validators.required]],
            issuedAtTime: ['', [Validators.required]],
            url: ['', [Validators.required, Validators.maxLength(300), Validators.pattern(URL_REGEX)]],
            observation: ['', [Validators.maxLength(500)]],
        });
    }

    preview(): void {
        const control = this.form.get('url');
        const url = control?.value;
        if (control?.valid) {
            window.open(url, '_blank', 'noopener');
            return;
        }
        control?.markAsTouched();
        control?.updateValueAndValidity();
    }

    save(): void {
        if (this.form.invalid) {
            this.form.markAllAsTouched();
            return;
        }

        this.saving = true;
        const url = this.form.value.url;
        const observation = this.form.value.observation || undefined;
        const issuedAtDate = this.form.value.issuedAt as Date;
        const [hours, minutes] = (this.form.value.issuedAtTime as string).split(':').map(Number);
        const combined = new Date(issuedAtDate);
        combined.setHours(hours, minutes, 0, 0);
        const issuedAt = combined.toISOString();

        this.service.attachReport(this.indicationId, { scheduleId: this.schedule.id, url, issuedAt, observation }).subscribe(
            () => {
                this.saving = false;
                this.form.reset();
                this.snack.open('Laudo anexado com sucesso.', undefined, { duration: 2000 });
                this.attached.emit();
            },
            () => {
                this.saving = false;
                this.snack.open('Não foi possível anexar o laudo. Tente novamente.', undefined, { duration: 3000 });
            }
        );
    }
}
